/** O Responsável do veículo da Frota Leve (reestruturação dos Abastecimentos,
 *  04/11/2026): a filial ou a Colheita que responde pelo carro, informada por veículo
 *  no cadastro da frota. A aba Frota Leve dos Abastecimentos mostra a coluna e filtra
 *  por ela. A mesma lista do backend, `RESPONSAVEIS_FROTA_LEVE`. */
import type { ResponsavelFrotaLeve } from '../core/api/types'

export const RESPONSAVEIS_FROTA_LEVE: readonly ResponsavelFrotaLeve[] = [
  'patos_de_minas', 'uberlandia', 'itumbiara', 'formosa', 'paracatu', 'colheita',
]

/** Só a Frota Leve recebe o campo. */
export const CATEGORIA_COM_RESPONSAVEL = 'utilitario'

export const ROTULO_DO_RESPONSAVEL: Record<ResponsavelFrotaLeve, string> = {
  patos_de_minas: 'Patos de Minas',
  uberlandia: 'Uberlândia',
  itumbiara: 'Itumbiara',
  formosa: 'Formosa',
  paracatu: 'Paracatu',
  colheita: 'Colheita',
}

export function ehResponsavel(valor: unknown): valor is ResponsavelFrotaLeve {
  return typeof valor === 'string' && (RESPONSAVEIS_FROTA_LEVE as readonly string[]).includes(valor)
}
